import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

import { I18n } from '@ngx-translate/i18n-polyfill';

import { ErrorModel } from '@core/api';

import { RecoveryService } from '../../services/recovery.service';
import { RequestIdService } from '../../services/request-id.service';

@Component({
  selector: 'auth-recovery-password-phone',
  templateUrl: './recovery-password-phone.component.html',
  styleUrls: ['./recovery-password-phone.component.scss']
})
export class RecoveryPasswordPhoneComponent implements OnInit {
  titleText = this.i18n('Создание (восстановление) пароля');
  btnText = this.i18n('Далее');

  errors = null;
  loading = false;

  constructor(
    private requestIdService: RequestIdService,
    private recoveryService: RecoveryService,
    private router: Router,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.requestIdService.reset();
  }

  submit(value) {
    this.loading = true;

    this.recoveryService.checkPhone(value)
      .pipe(finalize(() => this.loading = false))
      .subscribe(data => {
          this.router.navigate(['/auth/recovery-password/confirmation-code']);
        },
        (err: ErrorModel) => {
          console.log(err);
          this.errors = err;
        });
  }

}
